export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="inicio" className="relative min-h-screen w-full overflow-hidden">
      {/* Imagen de fondo */}
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/4ebe2c70aa72ef2c6dfc01f370e8f72f/4b868cd1b482cb5a038c35191f9c5aa1.jpeg"
          alt="Construcción y remodelación profesional"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70"></div>
      </div>

      {/* Contenido principal — flujo vertical: título → botones → tarjetas */}
      <div className="relative z-10 flex flex-col min-h-screen max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 pt-28 sm:pt-32 pb-10">

        {/* ── BLOQUE SUPERIOR: etiqueta + título + subtítulo ── */}
        <div className="flex flex-col items-center text-center mt-4 sm:mt-6">
          {/* Etiqueta */}
          <div className="inline-flex items-center px-4 py-2 border-2 border-[#C9A86A] bg-white/10 backdrop-blur-sm rounded-full mb-5 sm:mb-6 w-fit">
            <span className="text-white text-xs font-semibold tracking-wider uppercase">
              Más de 15 años de experiencia
            </span>
          </div>

          {/* Título principal */}
          <h1 className="text-3xl sm:text-5xl lg:text-7xl font-extrabold text-white leading-snug sm:leading-tight mb-4 sm:mb-5 max-w-xs sm:max-w-2xl lg:max-w-5xl">
            Construcción y mantenimiento profesional en Saltillo y zona metropolitana de Monterrey
          </h1>

          {/* Texto descriptivo */}
          <p className="text-base sm:text-xl lg:text-2xl text-white font-light mb-8 sm:mb-10 max-w-xs sm:max-w-xl lg:max-w-3xl leading-relaxed">
            Más de 15 años ejecutando proyectos de construcción, mantenimiento e instalaciones con resultados duraderos.
          </p>

          {/* ── BOTONES CTA ── */}
          <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-4 sm:gap-5 mb-10 sm:mb-12 w-full sm:w-auto">
            <button
              onClick={() => scrollToSection('contacto')}
              className="group px-8 py-4 bg-[#C9A86A] text-[#1A1A2E] rounded-full font-semibold text-base sm:text-lg hover:bg-[#B8935A] transition-all flex items-center justify-center gap-3 whitespace-nowrap"
            >
              Solicitar Cotización
              <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
            </button>
            <button
              onClick={() => scrollToSection('proyectos')}
              className="px-8 py-4 border-[3px] border-[#C9A86A] text-white rounded-full font-semibold text-base sm:text-lg hover:bg-[#C9A86A]/20 transition-all whitespace-nowrap"
            >
              Ver Proyectos
            </button>
          </div>
        </div>

        {/* ── TARJETAS DE SERVICIOS — parte inferior ── */}
        <div className="mt-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-stretch">
            {/* Tarjeta 1 - Construcción */}
            <div className="bg-white rounded-2xl overflow-hidden flex flex-col transform hover:-translate-y-2 transition-transform duration-300">
              <div className="h-44 overflow-hidden flex-shrink-0">
                <img
                  src="https://static.readdy.ai/image/4ebe2c70aa72ef2c6dfc01f370e8f72f/0c73adc2b29a5c5d5949390e28e0ea60.jpeg"
                  alt="Construcción"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <div className="w-12 h-12 bg-[#C9A86A]/10 rounded-full flex items-center justify-center mb-3 flex-shrink-0">
                  <i className="ri-building-line text-[#C9A86A] text-xl"></i>
                </div>
                <h3 className="text-lg font-bold text-[#1A1A2E] mb-1">Construcción</h3>
                <p className="text-[#7D7D7D] text-sm leading-relaxed">
                  Desarrollamos proyectos de construcción para hogares y espacios comerciales, con materiales de calidad y ejecución confiable.
                </p>
              </div>
            </div>

            {/* Tarjeta 2 - Remodelación */}
            <div className="bg-white rounded-2xl overflow-hidden flex flex-col transform hover:-translate-y-2 transition-transform duration-300">
              <div className="h-44 overflow-hidden flex-shrink-0">
                <img
                  src="https://static.readdy.ai/image/4ebe2c70aa72ef2c6dfc01f370e8f72f/148525a4b01f1aaa6a55433664c0d444.jpeg"
                  alt="Remodelación"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <div className="w-12 h-12 bg-[#C9A86A]/10 rounded-full flex items-center justify-center mb-3 flex-shrink-0">
                  <i className="ri-home-gear-line text-[#C9A86A] text-xl"></i>
                </div>
                <h3 className="text-lg font-bold text-[#1A1A2E] mb-1">Remodelación</h3>
                <p className="text-[#7D7D7D] text-sm leading-relaxed">
                  Transformamos espacios con remodelaciones funcionales, acabados duraderos y soluciones adaptadas a cada proyecto.
                </p>
              </div>
            </div>

            {/* Tarjeta 3 - Mantenimiento */}
            <div className="bg-white rounded-2xl overflow-hidden flex flex-col transform hover:-translate-y-2 transition-transform duration-300">
              <div className="h-44 overflow-hidden flex-shrink-0">
                <img
                  src="https://public.readdy.ai/ai/img_res/edited_fa38eb1ef8ee51d7210a36086b388aeb_c556c30c.jpg"
                  alt="Mantenimiento"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <div className="w-12 h-12 bg-[#C9A86A]/10 rounded-full flex items-center justify-center mb-3 flex-shrink-0">
                  <i className="ri-tools-line text-[#C9A86A] text-xl"></i>
                </div>
                <h3 className="text-lg font-bold text-[#1A1A2E] mb-1">Mantenimiento</h3>
                <p className="text-[#7D7D7D] text-sm leading-relaxed">
                  Realizamos mantenimiento preventivo y correctivo en instalaciones eléctricas, plomería y más, asegurando funcionamiento continuo.
                </p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
